var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectEnvironments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.158 20.08a.398.398 0 0 1-.4.395H3.742a.398.398 0 0 1-.4-.395V3.87c0-.218.179-.395.4-.395h4.016c.221 0 .4.177.4.396v16.21Zm-.8-.395V4.265H4.142v15.42h3.216Zm7.117-11.793a.4.4 0 0 1-.4.4h-4.017a.4.4 0 0 1-.4-.4V3.875c0-.22.18-.4.4-.4h4.017c.22 0 .4.18.4.4v4.017Zm-.8-.4V4.275h-3.217v3.217h3.217Zm4.575-.002a1.608 1.608 0 1 0 0-3.215 1.608 1.608 0 0 0 0 3.216Zm2.408-1.607a2.408 2.408 0 1 1-4.815 0 2.408 2.408 0 0 1 4.815 0Zm-6.183 8.125a.4.4 0 0 1-.4.4h-4.017a.4.4 0 0 1-.4-.4V9.992a.4.4 0 0 1 .4-.4h4.017a.4.4 0 0 1 .4.4v4.016ZM20.658 12a2.408 2.408 0 1 1-4.815 0 2.408 2.408 0 0 1 4.815 0Zm-6.183 8.125a.4.4 0 0 1-.4.4h-4.017a.4.4 0 0 1-.4-.4v-4.017a.4.4 0 0 1 .4-.4h4.017a.4.4 0 0 1 .4.4v4.017Zm-.8-.4v-3.217h-3.217v3.217h3.217Zm4.575-.002a1.608 1.608 0 1 0 0-3.215 1.608 1.608 0 0 0 0 3.215Zm2.408-1.607a2.408 2.408 0 1 1-4.815 0 2.408 2.408 0 0 1 4.815 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectEnvironments);
export default __webpack_public_path__ + "static/media/project-environments.f85f378d007a4ba793d5939a842f4f06.svg";
export { ForwardRef as ReactComponent };